import React from "react";

const SOCIAL_LINKS = [
  {
    key: "fb",
    field: "fbLink",
    icon: "fab fa-facebook-f",
    label: "Facebook",
    color: "#1877F2",
  },
  // {
  //   key: "wap",
  //   field: "wapLink",
  //   icon: "fab fa-whatsapp",
  //   label: "WhatsApp",
  //   color: "#25D366",
  // },
  {
    key: "linkedin",
    field: "wapLink",
    icon: "fab fa-linkedin-in",
    label: "LinkedIn",
    color: "#0A66C2",
  },
  {
    key: "yt",
    field: "ytLink",
    icon: "fab fa-youtube",
    label: "YouTube",
    color: "#FF0000",
  },
];

const AdvertisementSocialLinks = ({ item }) => {
  const links = SOCIAL_LINKS.map((social) => ({
    ...social,
    url: item?.[social.field]?.trim(),
  })).filter((social) => social.url);

  if (links.length === 0) {
    return null;
  }

  return (
    <div className="ad-social-links mt-3 pt-2 border-top">
      {links.map((social) => (
        <a
          key={social.key}
          href={social.url}
          target="_blank"
          rel="noopener noreferrer"
          className="ad-social-link"
          aria-label={social.label}
          title={social.label}
          style={{ backgroundColor: social.color }}
        >
          <i className={social.icon}></i>
        </a>
      ))}
    </div>
  );
};

export default AdvertisementSocialLinks;
